import React from 'react'
import { useInView } from 'react-intersection-observer'

import { selectors } from '@sketch/constants'

import { PageBeginnerMarker, StyledHeader } from './Header.styles'
import { useForTablet } from '../Breakpoint'
import { useSidebarWidth } from '../SplitLayout/sidebarWidth.context'
import { useLayoutContext, workspaceSidebarLayoutSymbols } from '@sketch/utils'

export const useMobileScrolled = () => {
  const [isScrolled, setIsScrolled] = React.useState(false)
  const isTabletAndBigger = useForTablet()
  const isMobile = !isTabletAndBigger

  React.useEffect(() => {
    const scrollingContainer = document.querySelector(
      selectors.contentScrollable
    )

    // Only run this effect on mobile
    if (isMobile && scrollingContainer) {
      const handleScroll = () => {
        setIsScrolled(scrollingContainer.scrollTop > 10)
      }

      scrollingContainer.addEventListener('scroll', handleScroll, {
        capture: true,
      })

      return () => {
        scrollingContainer.removeEventListener('scroll', handleScroll, {
          capture: true,
        })
      }
    }
  }, [isMobile])

  return isScrolled
}

const useShouldShowStickyHeader = () => {
  const { exists } = useLayoutContext()
  const portalExists = exists(workspaceSidebarLayoutSymbols.headerSlim)

  // We only want to show the slim header for tablet and desktop views
  const isTabletAndBigger = useForTablet()

  return isTabletAndBigger && portalExists
}

export const Header: React.FC = ({ children }) => {
  const { ref, inView } = useInView({
    initialInView: true,
  })

  const { ref: markerRef, inView: beginnerMarker } = useInView({
    initialInView: true,
  })

  const shouldShowStickyHeader = useShouldShowStickyHeader()
  const headerSticky = !inView && shouldShowStickyHeader
  const showBackground = !beginnerMarker && shouldShowStickyHeader
  const mobileScrolled = useMobileScrolled()
  const { sidebarWidth } = useSidebarWidth()

  return (
    <>
      <PageBeginnerMarker ref={markerRef} />
      <StyledHeader
        ref={ref}
        $sticky={headerSticky}
        $background={showBackground || headerSticky}
        $mobileScrolled={mobileScrolled}
        style={{
          // Passing css variables isn't recognized by CSSProperties TS Type, therefore, we overrule that
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          '--sidebar-width': `${sidebarWidth}px`,
        }}
      >
        {children}
      </StyledHeader>
    </>
  )
}
